<ion-header>
	<div class="header-block" role="banner">
		<!-- Back button -->
		<button class="back-button" (click)="goBack()" aria-label="Go back" tabindex="0">
			<ion-icon src="../../../assets/dean_and_david/back.svg" aria-hidden="true"></ion-icon>
			<span class="visually-hidden">Back</span>
		</button>

		<!-- Page title -->
		<h1 class="page-title">{{ 'menu_popover.orders' | translate }}</h1>

		<!-- Spacer for layout -->
		<div class="spacer" aria-hidden="true"></div>
	</div>
</ion-header>

<ion-content class="ion-padding" role="main">
	<div class="container">
		<ng-container>
			<!-- Empty state -->
			<div
				*ngIf="orders == null || orders.length <= 0"
				class="empty-state ion-text-center ion-justify-content-center ion-margin"
				role="status"
				aria-live="polite"
			>
				<p class="empty-message">{{ 'my_order.empty_finished_orders' | translate }}</p>
			</div>

			<!-- Orders carousel -->
			<div *ngIf="orders.length > 0" class="orders-section">
				<!-- Screen reader heading -->
				<h2 class="visually-hidden">{{ 'my_order.orders_heading' | translate }}</h2>

				<!-- Carousel container -->
				<swiper-container
					#swiperMyOrders
					swiperElement
					[config]="slideOptions"
					[pagination]="true"
					[loop]="orders.length > 1"
					role="region"
					aria-label="Order history carousel"
					[attr.aria-describedby]="'carousel-instructions'"
				>
					<!-- Order slides -->
					<swiper-slide
						*ngFor="let order of orders; let i = index"
						[id]="order?._id"
						class="slide"
						role="tabpanel"
						[attr.aria-label]="'Order ' + (i + 1) + ' of ' + orders.length"
						[attr.aria-describedby]="'order-' + i + '-details'"
					>
						<app-my-order [order]="order" class="ion-margin-horizontal" [attr.id]="'order-' + i + '-details'"> </app-my-order>
					</swiper-slide>
				</swiper-container>

				<!-- Carousel instructions for screen readers -->
				<div id="carousel-instructions" class="visually-hidden">
					Use left and right arrow keys to navigate between orders. {{ orders.length }} orders available.
				</div>
			</div>
		</ng-container>
	</div>
</ion-content>

<!-- Footer with reorder action -->
<ion-footer *ngIf="orders.length > 0" role="contentinfo">
	<div class="footer-content">
		<!-- Reorder button -->
		<button class="reorder-button" (click)="selectOrder()" *ngIf="!loading" aria-label="Reorder selected items" tabindex="0">
			{{ 'my_order.reorder' | translate }}
		</button>

		<!-- Loading spinner -->
		<div *ngIf="loading" class="loading-container" role="status" aria-live="polite">
			<ion-spinner name="crescent" aria-label="Processing reorder"></ion-spinner>
			<span class="visually-hidden">Processing your reorder request...</span>
		</div>
	</div>
</ion-footer>
